import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Navigation, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./Testimonials.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";

const testimonials = [
  {
    name: "Rajesh Gupta",
    text: "Muktinath Darshan was a truly divine experience. Everything from Kathmandu stay to temple darshan was perfectly arranged.",
    image: "/Images/tour/man.png",
  },
  {
    name: "Sunita Sharma",
    text: "Our Muktinath Yatra became stress-free because of the excellent planning and support team. Highly recommended!",
    image: "/Images/tour/woman.png",
  },
  {
    name: "Amit Verma",
    text: "Helicopter darshan was smooth and well managed. We completed the pilgrimage comfortably with senior citizens.",
    image: "/Images/tour/man.png",
  },
  {
    name: "Meena Patel",
    text: "The spiritual atmosphere at Muktinath Temple was unforgettable. Thank you for making our journey safe and memorable.",
    image: "/Images/tour/woman.png",
  },
  {
    name: "Vikas Singh",
    text: "Excellent arrangements, clean hotels, and dedicated guidance throughout the Nepal pilgrimage. A blessed journey!",
    image: "/Images/tour/man.png",
  },
];

const Testimonials = () => {
  const swiperRef = useRef(null);

  return (
    <section className="testimonials">
      <h2 className="heading">
        Blessings from <span className="highlight">Muktinath Pilgrims</span>
      </h2>

      <p className="subheading">
        Devotees share their sacred journey and spiritual experiences at
        Muktinath Dham.
      </p>

      <Swiper
        effect="coverflow"
        grabCursor
        centeredSlides={true}
        loop={true}
        slidesPerView={3}
        initialSlide={0}
        slidesPerGroup={1}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 150,
          modifier: 1,
          slideShadows: false,
          scale: 0.75,
        }}
        pagination={{ clickable: true }}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        navigation={{
          nextEl: ".testimonials-redesign .swiper-next",
          prevEl: ".testimonials-redesign .swiper-prev",
        }}
        modules={[EffectCoverflow, Pagination, Navigation, Autoplay]}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
      >
        {testimonials.map((t, idx) => (
          <SwiperSlide key={idx}>
            <div className="card">
              <div className="avatar-wrapper">
                <img src={t.image} alt={t.name} className="avatar" />
              </div>

              <p className="text">“{t.text}”</p>
              <h4 className="name">— {t.name}</h4>
            </div>
          </SwiperSlide>
        ))}

        <div
          className="swiper-prev"
          onClick={() => swiperRef.current?.slidePrev()}
        >
          <FaChevronLeft />
        </div>

        <div
          className="swiper-next"
          onClick={() => swiperRef.current?.slideNext()}
        >
          <FaChevronRight />
        </div>
      </Swiper>
    </section>
  );
};

export default Testimonials;